module.exports = __webpack_public_path__ + "img/login_home.3c364013.png";